import { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Footer from '../components/layout/Footer'
import Topbar from '../components/layout/Topbar'
import { fetchLeaderboard } from '../services/api'

type LeaderboardType = 'users' | 'projects' | 'agents'

export default function Leaderboard() {
  const navigate = useNavigate()
  const [type, setType] = useState<LeaderboardType>('users')
  const [data, setData] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const loadLeaderboard = useCallback(async () => {
    try {
      setLoading(true)
      setError(null)
      const result = await fetchLeaderboard(type)
      setData(result)
    } catch (err) {
      console.error('Liderlik tablosu yukleme hatasi:', err)
      setError((err as Error).message ?? 'Liderlik tablosu yuklenemedi')
    } finally {
      setLoading(false)
    }
  }, [type])

  useEffect(() => {
    void loadLeaderboard()
  }, [loadLeaderboard])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>      <div style={{ flex: 1, overflow: 'auto' }}>
        <Topbar />
        <div style={{ flex: 1, overflow: 'auto', padding: '20px', backgroundColor: 'var(--bg-primary)' }}>
          <div style={{ marginBottom: '30px' }}>
            <h1 style={{ fontSize: '28px', fontWeight: 'bold', marginBottom: '10px', color: 'var(--text-primary)' }}>Liderlik Tablosu</h1>
            <p style={{ color: 'var(--text-secondary)' }}>En basarili kullanicilar, projeler ve agentlar</p>
          </div>

          {/* Tabs */}
          <div style={{ display: 'flex', gap: '15px', marginBottom: '30px', borderBottom: '1px solid var(--border-color)' }}>
            {(['users', 'projects', 'agents'] as LeaderboardType[]).map((tab) => (
              <button key={tab} onClick={() => setType(tab)} style={{ padding: '12px 0', backgroundColor: 'transparent', border: 'none', borderBottom: type === tab ? '2px solid var(--primary-color)' : '2px solid transparent', color: type === tab ? 'var(--primary-color)' : 'var(--text-secondary)', fontSize: '14px', fontWeight: '500', cursor: 'pointer', transition: 'all 0.2s' }}>
                {tab === 'users' ? 'Kullanicilar' : tab === 'projects' ? 'Projeler' : 'Agentlar'}
              </button>
            ))}
          </div>

          {loading && <div style={{ textAlign: 'center', padding: '60px 20px', color: 'var(--text-secondary)' }}>Yukleniyor...</div>}

          {error && !loading && (
            <div style={{ textAlign: 'center', padding: '60px 20px', color: 'var(--error-color)', backgroundColor: 'var(--bg-secondary)', borderRadius: '12px' }}>
              <p style={{ fontSize: '16px', marginBottom: '10px' }}>Hata: {error}</p>
              <button onClick={() => void loadLeaderboard()} style={{ padding: '8px 16px', backgroundColor: 'var(--primary-color)', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>Tekrar Dene</button>
            </div>
          )}

          {!loading && !error && data.length === 0 && (
            <div style={{ textAlign: 'center', padding: '60px 20px', backgroundColor: 'var(--bg-secondary)', borderRadius: '12px' }}>
              <p style={{ fontSize: '16px', color: 'var(--text-secondary)' }}>Henuz veri yok</p>
            </div>
          )}

          {!loading && !error && data.length > 0 && (
            <div style={{ display: 'grid', gap: '15px' }}>
              {data.map((item, index) => (
                <div key={index} onClick={() => type === 'users' ? navigate(`/profile/${item.username}`) : type === 'projects' ? navigate(`/project/${item.id}`) : navigate(`/agent/${item.id}`)} style={{ display: 'flex', alignItems: 'center', gap: '20px', padding: '20px', backgroundColor: 'var(--bg-secondary)', border: '1px solid var(--border-color)', borderRadius: '12px', cursor: 'pointer', transition: 'all 0.2s' }} onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.1)' }} onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none' }}>
                  {/* Rank */}
                  <div style={{ width: '50px', height: '50px', borderRadius: '50%', backgroundColor: index === 0 ? '#FFD700' : index === 1 ? '#C0C0C0' : index === 2 ? '#CD7F32' : 'var(--bg-tertiary)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', fontWeight: 'bold', color: index < 3 ? 'white' : 'var(--text-secondary)' }}>
                    {index + 1}
                  </div>

                  {/* Info */}
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '18px', fontWeight: '600', color: 'var(--text-primary)', marginBottom: '4px' }}>
                      {type === 'users' ? item.display_name : item.title || item.name}
                    </div>
                    <div style={{ fontSize: '14px', color: 'var(--text-tertiary)' }}>
                      {type === 'users' ? `@${item.username}` : type === 'projects' ? item.category : item.type}
                    </div>
                  </div>

                  {/* Score */}
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: '24px', fontWeight: 'bold', color: 'var(--primary-color)' }}>
                      {type === 'users' ? item.reputation : type === 'projects' ? `$${item.reward_pool}` : item.performance_score}
                    </div>
                    <div style={{ fontSize: '12px', color: 'var(--text-tertiary)' }}>
                      {type === 'users' ? 'Itibar' : type === 'projects' ? 'Odul' : 'Performans'}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        <Footer />
      </div>
    </div>
  )
}
